import RestrictNonAdmin from '~/middleware/admin';
import RestrictNonAdminAndRep from '~/middleware/admin-rep';
import RestrictWhenPriceHidden from '~/middleware/restrict-when-price-hidden'

function page (path) {
  return () =>
    import(/* webpackChunkName: '' */ `~/pages/${path}`).then(
      m => m.default || m
    )
}

export default [
  { path: '/', redirect: { name: 'login' } },

  { path: '/login', name: 'login', component: page('auth/login.vue') },
  {
    path: '/account-access',
    name: 'account-access',
    component: page('auth/account-access.vue')
  },
  {
    path: '/wholesale-account',
    name: 'wholesale-account',
    component: page('auth/wholesale-account.vue')
  },
  {
    path: '/wholesale-thankyou',
    name: 'wholesale-thankyou',
    component: page('auth/wholesale-account-thankyou.vue')
  },
  {
    path: '/activate-account',
    name: 'activate-account',
    component: page('auth/activate-account.vue')
  },
  {
    path: '/activate-thankyou',
    name: 'activate-thankyou',
    component: page('auth/activate-account-thankyou.vue')
  },
  {
    path: '/register',
    name: 'register',
    component: page('auth/register.vue')
  },
  {
    path: '/password/reset',
    name: 'password.request',
    component: page('auth/password/email.vue')
  },
  {
    path: '/password/reset/:token',
    name: 'password.reset',
    component: page('auth/password/reset.vue')
  },
  {
    path: '/email/verify/:id',
    name: 'verification.verify',
    component: page('auth/verification/verify.vue')
  },
  {
    path: '/email/resend',
    name: 'verification.resend',
    component: page('auth/verification/resend.vue')
  },

  { path: '/home', name: 'home', component: page('home.vue') },
  {
    path: '/update-password',
    name: 'update-password',
    component: page('auth/update-password.vue')
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: page('dashboard/index.vue')
  },
  {
    path: '/tag-module',
    name: 'tag-module',
    component: page('tag-module/index.vue')
  },
  {
    path: '/collections',
    name: 'collections',
    component: page('collections/index.vue')
  },
  {
    path: '/collections/:id/line-sheet',
    name: 'collection-line-sheet',
    component: page('collections/line-sheet.vue')
  },
  {
    path: '/products',
    name: 'products',
    component: page('products/index.vue')
  },
  // {
  //   path: '/products/:brandId/:id/:tab',
  //   name: 'products-department',
  //   component: page('products/index.vue')
  // },
  // {
  //   path: '/products/:brandId/:departmentId/:id/:tab',
  //   name: 'products-category',
  //   component: page('products/index.vue')
  // },
  {
    path: '/order-history',
    component: page('order-history/index.vue'),
    children: [
      {
        path: '/',
        name: 'order-history.index',
        component: page('order-history/OrdersHistory.vue')
      },
      {
        path: 'draft',
        name: 'order-history.draft',
        component: page('order-history/DraftOrdersHistory.vue')
      },
      {
        path: 'invoices',
        name: 'order-history.invoices',
        component: page('order-history/InvoicesHistory.vue')
      }
    ]
  },
  {
    path: '/orders/:id',
    name: 'order.detail',
    component: page('orders/OrderDetail.vue'),
    beforeEnter: RestrictWhenPriceHidden
  },
  {
    path: '/contacts',
    name: 'contacts',
    component: page('contacts/index.vue'),
    beforeEnter: RestrictNonAdminAndRep
  },
  {
    path: '/contacts/create',
    name: 'contacts.create',
    component: page('contacts/ContactNewEdit.vue'),
    beforeEnter: RestrictNonAdminAndRep
  },
  {
    path: '/contacts/:id',
    name: 'contacts.edit',
    component: page('contacts/ContactNewEdit.vue'),
    beforeEnter: RestrictNonAdminAndRep
  },
  {
    path: '/settings',
    name: 'settings',
    component: page('settings/index.vue')
  },
  {
    path: '/checkout-proceed',
    component: page('checkout-proceed/index.vue'),
    children: [
      {
        path: '/',
        name: 'checkout-proceed.order-summary',
        component: page('checkout-proceed/components/OrderSummary.vue')
      },
      {
        path: 'order-review',
        name: 'checkout-proceed.order-review',
        component: page('checkout-proceed/components/OrderReview.vue')
      },
      {
        path: 'delivery-options',
        name: 'checkout-proceed.delivery-options',
        component: page('checkout-proceed/components/DeliveryOptions.vue')
      },
      {
        path: 'payment-details',
        name: 'checkout-proceed.payment-details',
        component: page('checkout-proceed/components/PaymentDetails.vue')
      },
      {
        path: 'payment-details',
        name: 'checkout-proceed.finished',
        component: page('checkout-proceed/components/OrderFinished.vue')
      }
    ]
  },
  {
    path: '/shop-by-gallery',
    name: 'shop-by-gallery',
    component: page('shop-by-gallery/index.vue')
  },
  {
    path: '/admin',
    name: 'admin',
    component: page('admin/index.vue')
  },
  {
    path: '/stock',
    name: 'stock',
    component: page('admin/stock/stock.vue')
  },
  {
    path: '/user-permission',
    name: 'user-permission',
    component: page('admin/user/user-permission.vue')
  },
  {
    path: '/user-permission/create',
    name: 'create-user-permission',
    component: page('admin/user/user-permission-form.vue')
  },
  {
    path: '/user-permission/:id',
    name: 'edit-user-permission',
    component: page('admin/user/user-permission-form.vue')
  },
  {
    path: '/imagery',
    name: 'imagery',
    component: page('admin/imagery.vue'),
    children: [
      {
        path: 'management',
        name: 'imagery-management',
        component: page('admin/imagery/ImagesManagement.vue')
      }
    ]
  },
  {
    path: '/approvals',
    name: 'approvals',
    component: page('admin/approvals.vue')
  },
  {
    path: '/companies',
    name: 'companies',
    component: page('admin/contact-management/index.vue')
  },
  {
    path: '/buyers',
    name: 'buyers',
    component: page('admin/contact-management/index.vue')
  },
  {
    path: '/addresses',
    name: 'addresses',
    component: page('admin/contact-management/index.vue')
  },
  {
    path: '/new-account-approval/:id',
    name: 'new-account-approval',
    component: page('admin/new-account-approval.vue')
  },
  {
    path: '/update-account-approval/:id',
    name: 'update-account-approval',
    component: page('admin/update-account-approval.vue')
  },
  {
    path: '/new-buyer-approval/:id',
    name: 'new-buyer-approval',
    component: page('admin/new-buyer-approval.vue')
  },
  {
    path: '/update-approval-request/:id',
    name: 'update-approval-request',
    component: page('admin/update-approval-request.vue')
  },
  {
    path: '/new-address-approval/:id',
    name: 'new-address-approval',
    component: page('admin/new-address-approval.vue')
  },
  // The tree and the product grid used to be two pages, /brands and /product-classification.
  // They are one tabbed module now, which lives at the URL the older one already had so that
  // anything linking to it keeps resolving. The two superseded paths redirect in.
  {
    // No route meta: the router only reads middleware off the matched component, and
    // index.vue declares its own. Meta here would read as a guard while doing nothing.
    path: '/brands',
    name: 'brands',
    component: page('admin/product-classifications/index.vue')
  },
  {
    path: '/product-classifications',
    redirect: { name: 'brands' }
  },
  {
    // The old grid carried its node in the query string; the tabbed module reads the same keys.
    path: '/product-classification',
    redirect: (to) => ({ name: 'brands', query: { ...to.query, tab: 'detail' } })
  },
  {
    path: '/admin-buyers',
    name: 'admin-buyers',
    component: page('admin/admin-buyers.vue')
  },
  {
    path: '/new-buyer',
    name: 'new-buyer',
    component: page('admin/new-buyer.vue')
  },
  {
    path: '/pre-order',
    name: 'pre-order',
    component: page('errors/404.vue')
  },
  {
    path: '/specials',
    name: 'specials',
    component: page('errors/404.vue')
  },
  {
    path: '/blog',
    name: 'blog',
    component: page('errors/404.vue')
  },
  {
        path: '/coupons',
        name: 'coupons',
        component: page('admin/coupons.vue')
  },
  {
        path: '/shipping-methods',
        name: 'shipping-methods',
        component: page('admin/shipping-methods.vue')
  },
  {
        path: '/orders-config',
        name: 'orders-config',
        component: page('admin/orders-config.vue')
  },
  {
    // Guarded by `middleware: ['auth', 'admin']` on the page component itself.
    // Route-level `meta.middleware` is NOT a working guard in this router —
    // router/index.js reads component.middleware and never looks at to.meta.
    path: '/mega-menu',
    name: 'mega-menu',
    component: page('admin/mega-menu/index.vue')
  },
  {
    // Guarded by `middleware: ['auth', 'admin']` on the page component.
    path: '/page-headers',
    name: 'page-headers',
    component: page('admin/page-headers/index.vue')
  },
  {
        path: '/coupons/create',
        name: 'coupon-create',
        component: page('admin/create-update-coupon.vue'),
  },
  {
        path: '/coupons/update/:couponId',
        name: 'coupon-update',
        component: page('admin/create-update-coupon.vue'),
        props: true,
  },
  {
        path: '/digital-catalog',
        component: page('digital-catalog/DigitalCatalog.vue'),
        children: [
            {
                path: '',
                name: 'digital-catalog',
                component: page('digital-catalog/DigitalCatalogList.vue'),
                props: true
            },
            {
                path: 'checkout',
                name: 'digital-catalog-checkout',
                component: page('digital-catalog/DigitalCatalogCheckout.vue'),
                props: true
            },
            {
                path: 'buyer-view',
                name: 'digital-catalog-buyer-view',
                component: page('digital-catalog/DigitalCatalogBuyerView.vue'),
                props: true
            }
        ]
  },
  { path: '*', component: page('errors/404.vue') }
]
